import { useEffect } from 'react';

export function HuggyWidget({ user }) {
  useEffect(() => {
    // Se não tem usuário logado, remove o widget
    if (!user) {
      const script = document.getElementById('huggy-script');
      if (script) script.remove();

      document
        .querySelectorAll('.powerzap_open_button_standardType_iframe')
        .forEach(el => el.remove());

      delete window.$_Huggy;
      delete window.pwz;

      console.log('Huggy removido: usuário deslogado');
      return;
    }

    // Se usuário existe, injeta o script
    if (!document.getElementById('huggy-script')) {
      const script = document.createElement('script');
      script.id = 'huggy-script';
      script.async = true;
      script.type = 'text/javascript';
      script.innerHTML = `
        var $_Huggy = { 
          defaultCountry: '+55', 
          uuid: 'd8ed4129-f899-4ca2-b60c-2a0dd27d1062', 
          company: '317059' 
        }; 
        (function(i,s,o,g,r,a,m){ 
          i[r]={context:{id:'73c8311ec498371d95eaa2ab4f9f6aed'}}; 
          a=o; o=s.createElement(o); o.async=1; o.src=g; 
          m=s.getElementsByTagName(a)[0]; m.parentNode.insertBefore(o,m); 
        })(window,document,'script','https://js.huggy.chat/widget.min.js','pwz');
      `;
      document.body.appendChild(script);

      console.log('Huggy injetado: usuário logado');
    }

    // Cleanup ao desmontar ou mudar user
    return () => {
      const script = document.getElementById('huggy-script');
      if (script) script.remove();

      document
        .querySelectorAll('.powerzap_open_button_standardType_iframe')
        .forEach(el => el.remove());

      delete window.$_Huggy;
      delete window.pwz;

      console.log('Huggy removido no cleanup');
    };
  }, [user]);

  return null;
}
